var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.link)?_c('span',[_c('a',{staticStyle:{"display":"inline"},attrs:{"href":_vm.link,"target":"_blank"}},[_c('font-awesome-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"},{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":"Link","icon":"external-link-alt"}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }